module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("umd 组件构建及使用")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("从"), _c('code', [_vm._v("2.0")]), _vm._v("开始，推荐使用"), _c('code', [_vm._v("webpack")]), _vm._v("来调用组件，因此不再在"), _c('code', [_vm._v("repo")]), _vm._v("中保存"), _c('code', [_vm._v("umd")]), _vm._v("文件，但提供了生成命令。")]), _vm._v(" "), _c('p', [_vm._v("请更新 "), _c('code', [_vm._v("NodeJS")]), _vm._v(" 到版本 "), _c('code', [_vm._v("7.6.0")]), _vm._v("及以上。")]), _vm._v(" "), _c('p', [_vm._v("例子可查看："), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/tree/v2/docs/examples"
    }
  }, [_vm._v("https://github.com/airyland/vux/tree/v2/docs/examples")])])]), _vm._v(" "), _c('div', {
    staticClass: "danger"
  }, [_c('p', [_vm._v("强烈建议使用 "), _c('code', [_vm._v("webpack")]), _vm._v(" 的方式开发，在 3.0 之后可能不再提供支持。")])]), _vm._v(" "), _c('h2', [_vm._v("生成命令")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("git "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("clone")]), _vm._v(" https://github.com/airyland/vux.git --depth=1 // or just update: git pull\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("cd")]), _vm._v(" vux\nnpm install\nnpm run build-components\n")])]), _vm._v(" "), _c('p', [_vm._v("默认生成的语言是"), _c('code', [_vm._v("zh-CN")]), _vm._v("，模块命名空间为"), _c('code', [_vm._v("vux")]), _vm._v("，如"), _c('code', [_vm._v("vuxGroup")]), _vm._v("，"), _c('code', [_vm._v("vuxCell")]), _vm._v("，你可以在命令行中配置。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm run build-components -- --locale='en' --namespace='X'\n")])]), _vm._v(" "), _c('h2', [_vm._v("目录结构")]), _vm._v(" "), _c('p', [_vm._v("生成的文件夹结构如：")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("出于目录结构一致性考虑，即使是子组件也是一个文件夹，并且会有一个空的"), _c('code', [_vm._v("index.min.css")]), _vm._v("样式文件。")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("|- dist/\n  |- vux.min.js ------------ 所有组件打包，仅用于测试，不推荐在生产环境使用\n  |- vux.min.css ----------- 所有组件样式打包，同样仅用于测试\n  |- components\n      |- actionsheet\n        |- index.min.js -------- 组件js代码\n        |- index.min.css ------- 组件css代码\n")])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("vux.min.js 包括了所有的组件、插件及默认地址库，都挂载在全局变量vux上。当然为了使用方便同样直接挂载到了"), _c('code', [_vm._v("window")]), _vm._v("上。")]), _vm._v(" "), _c('p', [_vm._v("组件调用举例: "), _c('code', [_vm._v("vuxCell")])]), _vm._v(" "), _c('p', [_vm._v("插件调用举例："), _c('code', [_vm._v("vuxAlertPlugin")])]), _vm._v(" "), _c('p', [_vm._v("默认地址库调用："), _c('code', [_vm._v("vuxChinaAddressData")])])]), _vm._v(" "), _c('h2', [_vm._v("组件使用")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-meta"
  }, [_vm._v("<!DOCTYPE html>")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("html")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("lang")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"en\"")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("head")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("meta")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("charset")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"UTF-8\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("title")]), _vm._v(">")]), _vm._v("scripts"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("title")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("link")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("rel")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"stylesheet\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("href")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"../dist/vux.min.css\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("src")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"https://unpkg.com/vue/dist/vue.js\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("head")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("body")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("id")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("cell")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"Vue\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":value")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"how\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("cell")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("group")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("src")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"../dist/components/group/index.js\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("src")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"../dist/components/cell/index.js\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _c('span', {
    staticClass: "actionscript"
  }, [_vm._v("\n  Vue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'group'")]), _vm._v(", vuxGroup)\n  Vue.component("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'cell'")]), _vm._v(", vuxCell)\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("new")]), _vm._v(" Vue({\n    el: "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'#demo'")]), _vm._v(",\n    data: {\n      how: "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Cool'")]), _vm._v("\n    }\n  })\n  ")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("body")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("html")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('h2', [_vm._v("插件使用")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-meta"
  }, [_vm._v("<!DOCTYPE html>")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("html")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("lang")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"en\"")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("head")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("meta")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("charset")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"UTF-8\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("meta")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"viewport\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("content")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"width=device-width,initial-scale=1,user-scalable=0\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("title")]), _vm._v(">")]), _vm._v("scripts"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("title")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("link")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("rel")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"stylesheet\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("href")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"../../dist/styles/reset.css\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("link")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("rel")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"stylesheet\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("href")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"../../dist/plugins/alert/index.min.css\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("src")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"https://unpkg.com/vue/dist/vue.js\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("head")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("body")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("id")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"demo\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("src")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"../../dist/plugins/alert/index.min.js\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _c('span', {
    staticClass: "actionscript"
  }, [_vm._v("\n  Vue.use(vuxAlertPlugin)\n\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("new")]), _vm._v(" Vue({\n    el: "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'#demo'")]), _vm._v(",\n    data: {\n      how: "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Cool'")]), _vm._v("\n    },\n    mounted () {\n      "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$vux.alert.show("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'hello'")]), _vm._v(")\n    }\n  })\n  ")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("body")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("html")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('h2', [_vm._v("生成css工具样式")]), _vm._v(" "), _c('p', [_vm._v("包括"), _c('code', [_vm._v("1px")]), _vm._v("解决方案，构建文件位于"), _c('code', [_vm._v("dist/styles/*.css")]), _vm._v(",构建方式：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm run build-styles\n")])]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("为了使用方便，可以使用"), _c('code', [_vm._v("npm run xbuild")]), _vm._v("来执行"), _c('code', [_vm._v("build-components")]), _vm._v(" 及 "), _c('code', [_vm._v("build-styles")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-60875178", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-60875178"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/umd-298.vue
// module id = 2286
// module chunks = 392